import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ProductoHojaEvaluacion} from '../_models/producto-hoja-evaluacion';
import {SolicitudUcCuentaContables} from '../_models/solicitud-uc-cuenta-contables';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductoHojaEvaluacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosHojaEvaluacion';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoHojaEvaluacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoHojaEvaluacion[] ) );
  }

  listadoHabilitadosPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/enabled' ).pipe( map( res => res as ProductoHojaEvaluacion[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoHojaEvaluacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoHojaEvaluacion ) );
  }

  crear( regCrear: ProductoHojaEvaluacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoHojaEvaluacion ) );
  }

  actualizar( regActualizar: ProductoHojaEvaluacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( productoHojaEvaluacion: ProductoHojaEvaluacion[] ): Observable<ProductoHojaEvaluacion[]> {
    productoHojaEvaluacion.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', productoHojaEvaluacion ).pipe( map( res => res as ProductoHojaEvaluacion[] ) );
  }

}
